import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import '@/core/lazy_lib/components_use' // 组件按需引入
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Storage from 'vue-ls' // localstorage
import spin from '@/plugins/spin/spin'
import { lsOptions } from '@/utils/util'

Vue.use(Storage, lsOptions)
Vue.use(Antd)
Vue.use(spin)

// 全局spin
Vue.use(spin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
